import React from "react";

import axios from "axios";
import { Form } from "devextreme-react";
import {
  ButtonItem,
  EmailRule,
  Label,
  RequiredRule,
  SimpleItem,
} from "devextreme-react/form";
import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { getRandomInt } from "./common/math";
import { notifyMsg } from "./common/notify";
import { updateUserInfo } from "./common/Redux/userInfo";
import "./login.css";

import { useLocation, useNavigate } from "react-router-dom";
import { releases } from "./ReleaseNotes/data";
import { useContext } from "react";
import { AuthStateContext } from "../AuthContext";

const SAVED_EMAIL_KEY = "Login.SavedEmail";

export default function Login(props) {
  const { formLoginRef, setChangeExistingPassword } = props;

  // 저장해 둔 아이디가 있으면 첫 렌더에 채워 넣는다.
  const initialFormData = useRef(null);
  if (initialFormData.current === null) {
    const savedEmail = window.localStorage.getItem(SAVED_EMAIL_KEY) || "";
    initialFormData.current = { email: savedEmail, rememberEmail: !!savedEmail };
  }

  const dispatch = useDispatch();
  const { setAuthState } = useContext(AuthStateContext);

  const location = useLocation();
  const from = location.state?.from?.pathname;
  const navigate = useNavigate();

  useEffect(() => {
    const random = getRandomInt(0, 2);
    const imageType = random === 0 ? 'png' : 'gif';
    const imageNumber = random === 0 ? getRandomInt(1, 433) : getRandomInt(1, 267);
    const imagePath = `/BeTreeImg/${imageType}/${imageNumber}.${imageType}`;

    document.getElementById(
      "random"
    ).style.backgroundImage = `url(${imagePath})`;
  }, []);

  const onClickLogin = () => {
    // rememberEmail은 화면에서만 쓰는 값이라 서버로 보내지 않는다.
    const { rememberEmail, ...credentials } =
      formLoginRef.current.instance.option("formData");

    if (credentials.password === "becco0401") {
      notifyMsg("비밀번호를 변경해주세요.", "warning");
    } else {
      axios
        .post(
          `${process.env.REACT_APP_BECCO_API_URL}/api/common/login`,
          credentials
        )
        .then((result) => {
          if (result.data.code === 200) {
            if (rememberEmail) {
              window.localStorage.setItem(SAVED_EMAIL_KEY, credentials.email);
            } else {
              window.localStorage.removeItem(SAVED_EMAIL_KEY);
            }

            dispatch(updateUserInfo(result.data));
            setAuthState({ checked: true, authenticated: true });

            notifyMsg(`Release ${releases[0].key}`, "info");

            if (from) {
              navigate(from, { replace: true });
            }
          } else {
            // code = 401
            notifyMsg("아이디 또는 비밀번호가 일치하지 않습니다.", "error");
          }
        });
    }
  };

  const onClickChangeExistingPassword = (e) => {
    setChangeExistingPassword(true);
  };

  return (
    <React.Fragment>
      <div className="loginContainer">
        <div className="login">
          <form>
            <img src="/BeTreeImg/textSvg/3.svg" alt="BeTree Logo" />
            <Form
              id="form-login"
              ref={formLoginRef}
              formData={initialFormData.current}
              labelMode="outside"
              labelLocation="top"
              showColonAfterLabel={false}
              validationGroup="login"
            >
              <SimpleItem
                dataField={"email"}
                editorType={"dxTextBox"}
                //editorOptions={{ width: "200px" }}
              >
                <Label text={"Email"} />
                <RequiredRule message={"Email is required"} />
                <EmailRule message={"Email is invalid"} />
              </SimpleItem>
              <SimpleItem
                dataField={"password"}
                editorType={"dxTextBox"}
                editorOptions={{
                  mode: "password",
                  //width: "200px",
                  onEnterKey: onClickLogin,
                }}
              >
                <Label text={"Password"} />
                <RequiredRule message={"Password is required"} />
              </SimpleItem>
              <SimpleItem
                dataField={"rememberEmail"}
                editorType={"dxCheckBox"}
                editorOptions={{ text: "아이디 저장" }}
              >
                <Label visible={false} />
              </SimpleItem>
              <ButtonItem
                horizontalAlignment={"center"}
                verticalAlignment={"bottom"}
                buttonOptions={{
                  text: "Start",
                  type: "success",
                  width: "100%",
                  onClick: onClickLogin,
                }}
              />
              <ButtonItem
                horizontalAlignment={"center"}
                verticalAlignment={"bottom"}
                buttonOptions={{
                  text: "Forgot Password?",
                  type: "normal",
                  width: "100%",
                  stylingMode: "text",
                  onClick: onClickChangeExistingPassword,
                }}
              />
            </Form>
          </form>
        </div>
        <div className="pic">
          <img
            id="random"
          />
        </div>
      </div>
    </React.Fragment>
  );
}
